
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from 'react-toastify';
import { useAuth } from '../../contexts/AuthContext';
import { fetchProfileImage, getProfile } from '../../services/userProfileService';
import { launchFundamentalAnalysis } from '../../services/ssoService';

export const Menu = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout, menus } = useAuth();
  
  const [profileImage, setProfileImage] = useState(null);
  const [displayName, setDisplayName] = useState('');

  useEffect(() => {
    if (!user?.id) return;
    let revoke;
    fetchProfileImage(user.id).then(url => {
      if (url) { revoke = url; setProfileImage(url); }
    });
    getProfile().then(p => {
      const name = [p.first_name, p.middle_name, p.last_name].filter(Boolean).join(' ');
      if (name) setDisplayName(name);
    }).catch(() => {});
    return () => { if (revoke) URL.revokeObjectURL(revoke); };
  }, [user?.id]);

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const handleLogoutKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleLogout();
    }
  };



  const toggleMenu = (id) => {
    const menu = document.getElementById(id);

    // Close all other sub-menus
    document.querySelectorAll('.sub-menu').forEach(subMenu => {
      if (subMenu.id !== id) {
        subMenu.style.display = "none";
      }
    });

    // Toggle clicked menu
    if (menu && (menu.style.display === "none" || menu.style.display === "")) {
      menu.style.display = "block";
    } else if (menu) {
      menu.style.display = "none";
    }

    // Remove 'active' from all li elements
    document.querySelectorAll('li.active').forEach(li => {
      li.classList.remove('active');
    });

    // Add 'active' to the clicked li
    // Note: This will be handled in handleMenuClick
  };

  const handleMenuClick = (e, item) => {
    const { path, menu_id, children } = item;
    const clickedLi = e.currentTarget;

    if (children && children.length > 0) {
      toggleMenu('menu-' + menu_id);
    } else if (path && item.label === 'Fundamental Analysis') {
      launchFundamentalAnalysis()
        .then(({ redirect_to }) => {
          if (redirect_to) window.open(redirect_to, '_blank', 'noopener,noreferrer');
        })
        .catch((err) => {
          // do not open the bare app URL: without a handoff code it just lands on FA's own login
          if (err?.response?.status === 401) {
            toast.error('Your session has expired. Please log in again, then open Fundamental Analysis.');
          } else {
            toast.error('Could not open Fundamental Analysis right now. Please try again.');
          }
        });
    } else if (path && /^https?:\/\//i.test(path)) {
      window.open(path, '_blank', 'noopener,noreferrer');
    } else if (path) {
      navigate(path);
    }

    // Remove 'active' from all li elements
    document.querySelectorAll('li.active').forEach(li => {
      li.classList.remove('active');
    });

    // Add 'active' to the clicked li
    clickedLi.classList.add('active');
  };

  const handleMenuKeyDown = (e, item) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleMenuClick(e, item);
    }
  };

  const isPathActive = (item) => {
    if (item.path && location.pathname === item.path) return true;
    if (item.children) return item.children.some(child => isPathActive(child));
    return false;
  };

  const renderMenu = (menuList) => {
    let sortedMenuList = menuList.filter(item => item.label !== 'Fundamental Analysis');
    const dashboardIndex = sortedMenuList.findIndex(item => item.label === 'Dashboard');
    if (dashboardIndex > 0) {
      const dashboardItem = sortedMenuList.splice(dashboardIndex, 1)[0];
      sortedMenuList.unshift(dashboardItem);
    }

    return (
      <ul>
        {sortedMenuList.map((item) => (
          <React.Fragment key={item.key || item.label}>
            <li
              className={`${item.class_name || ""} ${isPathActive(item) ? "active" : ""}`.trim()}
              onClick={(e) => handleMenuClick(e, item)}
              onKeyDown={(e) => handleMenuKeyDown(e, item)}
              style={{ cursor: item.path ? "pointer" : "default" }}
              tabIndex={0}
              role="menuitem"
            >
              {item.icon && <i className={item.icon}></i>} {item.label}
            </li>
            {item.children && item.children.length > 0 && (
              <ul className="sub-menu" id={`menu-${item.menu_id}`} style={{ display: item.children.some(c => isPathActive(c)) ? 'block' : '' }}>
                {renderMenu(item.children)}
              </ul>
            )}
          </React.Fragment>
        ))}
      </ul>
    );
  };

  return (
    <div>
       <div className="sidebar-close">
        <i className="fas fa-times"></i>
      </div>
      <div
        className="user-profile"
        onClick={() => navigate('/user-profile')}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); navigate('/user-profile'); } }}
        tabIndex={0}
        role="button"
        title="View Profile"
        style={{ cursor: 'pointer' }}
      >
        <div className="avatar-container">
          {profileImage ? (
            <img src={profileImage} alt="Profile" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} />
          ) : (
            <i className="fas fa-user"></i>
          )}
        </div>
        <div className="user-info">
          <h3>{displayName || user?.email_id}</h3>
          <p>{user?.is_active ? 'Active' : 'Inactive'}</p>
        </div>
      </div>
      <nav>
        {renderMenu(menus)}
      </nav>
      {/* <div className="sign-out" onClick={handleLogout} onKeyDown={handleLogoutKeyDown} tabIndex={0} role="button">
        <i className="fas fa-sign-out-alt"></i> Sign Out
      </div> */}
    </div>
  );
};


